// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4498) return "static/chunks/4498-f08171124a3efffc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2971":"cc25dd7e49842b08","3488":"9f2ef7b220e3e7d4","3592":"5b9244640cfa7cad","3849":"02b623c08f288d77","4997":"793e09f2c00f2e59"}[chunkId] + ".js";
};